import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, NavLink, useNavigate } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import PasswordStrengthBar from 'react-password-strength-bar';
import { useForm } from '../../presentation/hooks/useForm';
import { isPasswordValid } from '../../presentation/hooks/isFormValid';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import logo from './logo-final.svg';
import { LoadingScreen } from '../Layout/LoadingScreen';
import { recoveryPasswordUpdate } from '../action/recoveryPassword';
import { InputPass as InputMvv } from '@movivendor/mv-components';

export const PassRecoveryUpdate = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { isLoadingActive } = useSelector(state => state.uiState);
  const params = new URLSearchParams(window.location.search);
  const [message, setMessage] = useState(null);

  const [formValues, handleInputChange] = useForm({
    password: '',
    confirmPassword: ''
  });

  const { password, confirmPassword } = formValues;

  //useEffect que se ejecuta al montar el componente, elimina el elemento "auth" del localStorage para limpiar cualquier sesión de autenticación previa.
  useEffect(() => {
    localStorage.removeItem("auth");
  }, []);

  // Verifica si el parámetro 'token' está presente en la URL, si no está redirige al usuario a la página principal.
  if (!params.has('token')) {
    return <Navigate to="/" replace={true} />
  }

  // Maneja el envío del formulario de actualización de contraseña.
  const handleSubmit = e => {
    e.preventDefault();
    setMessage('');
    if (isPasswordValid(password, confirmPassword, setMessage)) {
      dispatch(UIActions.uiLoadActive());
      recoveryPasswordUpdate(params.get('token'), password, navigate, dispatch);
    }
  }

  return (
    <>
      {
        (isLoadingActive)
        &&
        <LoadingScreen />
      }
      <div className="login-container justify-content-center align-items-center d-flex flex-column body-gradient"
        style={{ top: '0px', bottom: '0px', left: '0px', right: '0px', position: 'fixed' }}>
        <div className="miclase col-lg-4 col-md-6 col-sm-12 bg-white shadow p-3">
          <form>
            {
              (message) &&
              <Alert variant="warning" onClose={() => setMessage(null)} dismissible>
                {message}
              </Alert>
            }
            <div className="row justify-content-center p-3">
              <img style={{ width: `12rem` }} src={logo} alt="logo redsmart" />
            </div>
            <div className="login-pdv text-center justify-content-center pt-3">
              <h2>Restablecer contraseña</h2>
            </div>
            <div className="row justify-content-center py-1 wrap-input-password">
              <InputMvv
                name="password"
                placeholder="Ingresa nueva contraseña"
                handleInputChange={handleInputChange}
                value={password}
                showPasswordStrength={true}
                autoComplete="new-password"
              />
            </div>
            <div className="row justify-content-center py-3 wrap-input-password">
              <InputMvv
                name="confirmPassword"
                placeholder="Confirmar nueva contraseña"
                handleInputChange={handleInputChange}
                value={confirmPassword}
                showPasswordStrength={false}
                autoComplete="new-password"
              />
            </div>
            {
              (password) &&
              <div className='px-3'>
                <PasswordStrengthBar
                  minLength='8'
                  shortScoreWord='demasiado corta'
                  scoreWords={['débil', 'débil', 'okey', 'buena', 'fuerte']}
                  password={password} />
              </div>
            }
            <div className="row justify-content-center py-3">
              <button type="submit" className="btn col-10" id="logIn" onClick={handleSubmit}>
                Restablecer contraseña
              </button>
            </div>
          </form>
          <div className='text-center'>
            <NavLink to="/login" replace={true}>
              <small>Regresar a Login</small>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  )
}